/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Bookora API
 * API for **bookora.net** — multi-tenant SaaS for Iranian beauty clinics and
 * aesthetic doctors.
 *
 * ## Conventions
 *
 * - **Versioning**: customer-facing routes live under `/api/v1/...`. The health
 *   probes (`/health`, `/ready`) are unprefixed and version-neutral.
 * - **Response envelope**: every successful JSON response is
 *   `{ "data": <payload>, "meta"?: <extra> }`.
 * - **Error envelope**: every error response is
 *   `{ "statusCode": number, "code": string, "message": string, "details"?: any, "requestId"?: string }`.
 *   `code` is a stable token from `ErrorCode`; `message` is finished Persian copy.
 * - **Pagination**: list endpoints take 1-indexed `?page=&pageSize=` and return
 *   `{ items, page, pageSize, total, pageCount }` inside `data`.
 * - **Auth**: bearer JWT. Tokens come from `/api/v1/auth/otp/verify` and rotate on
 *   `/api/v1/auth/refresh`. There are no passwords in this product.
 * - **Tenancy**: the access token carries the clinic. Every tenant-scoped query is
 *   filtered by it server-side; a `clinicId` in a path or body must agree with the
 *   token or the request is rejected.
 * - **Currency**: every money field is an integer in **rials**. Panels display
 *   toman (1 toman = 10 rials).
 * - **Quantities**: integer milli-units (`…Milli`, 1 unit = 1000).
 *   **Percentages**: basis points (`…PercentBp`, 1% = 100).
 * - **Timestamps**: UTC ISO-8601. Jalali conversion happens in the UI.
 * OpenAPI spec version: 0.1.0
 */
import {
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  DirectoryPreviewResponse
} from '../model';

import { apiClient } from '../../mutator';




const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

/**
 * می‌گوید صفحهٔ عمومی کلینیک زنده هست یا نه، و اگر نیست دقیقاً چرا — به تفکیک آنچه خود کلینیک می‌تواند درست کند و آنچه فقط مدیر سامانه می‌تواند. وقتی زنده باشد، همان کارتی را برمی‌گرداند که در دایرکتوری دیده می‌شود، به‌علاوهٔ شمار پزشکان، خدمات و نظرهای منتشرشده.
 * @summary وضعیت صفحهٔ عمومی کلینیک
 */
export const directoryPreviewStatus = (

 signal?: AbortSignal
) => {


      return apiClient<DirectoryPreviewResponse>(
      {url: `/api/v1/directory/preview`, method: 'GET', signal
    },
      );
    }




export const getDirectoryPreviewStatusQueryKey = () => {
    return [
    `/api/v1/directory/preview`
    ] as const;
    }


export const getDirectoryPreviewStatusQueryOptions = <TData = Awaited<ReturnType<typeof directoryPreviewStatus>>, TError = void>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof directoryPreviewStatus>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getDirectoryPreviewStatusQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof directoryPreviewStatus>>> = ({ signal }) => directoryPreviewStatus(signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof directoryPreviewStatus>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type DirectoryPreviewStatusQueryResult = NonNullable<Awaited<ReturnType<typeof directoryPreviewStatus>>>
export type DirectoryPreviewStatusQueryError = void


export function useDirectoryPreviewStatus<TData = Awaited<ReturnType<typeof directoryPreviewStatus>>, TError = void>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof directoryPreviewStatus>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof directoryPreviewStatus>>,
          TError,
          Awaited<ReturnType<typeof directoryPreviewStatus>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDirectoryPreviewStatus<TData = Awaited<ReturnType<typeof directoryPreviewStatus>>, TError = void>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof directoryPreviewStatus>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof directoryPreviewStatus>>,
          TError,
          Awaited<ReturnType<typeof directoryPreviewStatus>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDirectoryPreviewStatus<TData = Awaited<ReturnType<typeof directoryPreviewStatus>>, TError = void>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof directoryPreviewStatus>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary وضعیت صفحهٔ عمومی کلینیک
 */

export function useDirectoryPreviewStatus<TData = Awaited<ReturnType<typeof directoryPreviewStatus>>, TError = void>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof directoryPreviewStatus>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getDirectoryPreviewStatusQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






